module.exports = __webpack_public_path__ + "static/media/home7.b66771d3.jpg";